/** A row that may carry §25 translations alongside its base name. */
interface Translatable {
  name: string;
  description?: string | null;
  translations?: { locale: string; name: string; description?: string | null }[];
}

/**
 * The name to show, in the language the operator is working in.
 *
 * §25 keeps a translation as a row keyed by locale on the same item, and the
 * admin reads deliberately return the base name plus every row — the edit form
 * needs all of them at once. Display is the other half of that decision, and it
 * was missing: a venue whose products are named in Arabic showed Arabic
 * everywhere, including to staff who had put the dashboard in English.
 *
 * `GET /menus/guest` localises server-side from `x-lang`, so the guest app is
 * unaffected; this is the staff side of the same rule.
 *
 * Falls back to the base name rather than showing nothing — an item with no
 * translation for this locale is not an error, it is an item nobody has
 * translated yet.
 */
export function localizedName(item: Translatable, locale: string): string {
  return translationFor(item, locale)?.name || item.name;
}


/**
 * `ar-SA` and `ar` are the same language for this purpose — the server resolves
 * the region away too, so matching on the base subtag keeps the two consistent.
 */
function translationFor(item: Translatable, locale: string) {
  const base = locale.split('-')[0].toLowerCase();
  return item.translations?.find((row) => row.locale.split('-')[0].toLowerCase() === base);
}
